// WARNING: Do NOT edit this file outside npm-helsecore, it will be reset on build!

import type { KeyNumbersProps } from '@dip/helsecore/src/components/parts/KeyNumbers/KeyNumbers.d';

import React from 'react';
import { KeyNumbers } from '@dip/helsecore/src/components/parts/KeyNumbers/KeyNumbers';

export default (props: Readonly<KeyNumbersProps>) => <KeyNumbers {...props} />
